import { defineComponent as _defineComponent } from 'vue';
import { BTable } from "bootstrap-vue";
import { computed } from "vue";
import { DESCRIPTION_FIELD, NAME_FIELD, TEMPLATE_FIELD, TYPE_FIELD } from "@/components/ConfigTemplates/fields";
import { useInstanceTesting } from "@/components/ConfigTemplates/useConfigurationTesting";
import { useFiltering } from "@/components/ConfigTemplates/useInstanceFiltering";
import { useObjectStoreInstancesStore } from "@/stores/objectStoreInstancesStore";
import _l from "@/utils/localization";
import InstanceDropdown from "./InstanceDropdown.vue";
import ManageIndexHeader from "@/components/ConfigTemplates/ManageIndexHeader.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import ObjectStoreBadges from "@/components/ObjectStore/ObjectStoreBadges.vue";
import ObjectStoreTypeSpan from "@/components/ObjectStore/ObjectStoreTypeSpan.vue";
import TemplateSummarySpan from "@/components/ObjectStore/Templates/TemplateSummarySpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ManageIndex',
    props: {
        message: null
    },
    setup(__props) {
        const objectStoreInstancesStore = useObjectStoreInstancesStore();
        const BADGE_FIELD = {
            key: "badges",
            label: _l(" "),
            sortable: false,
        };
        const fields = [NAME_FIELD, DESCRIPTION_FIELD, TYPE_FIELD, TEMPLATE_FIELD, BADGE_FIELD];
        const allItems = computed(() => objectStoreInstancesStore.getInstances);
        const { activeInstances } = useFiltering(allItems);
        const loading = computed(() => objectStoreInstancesStore.loading);
        objectStoreInstancesStore.fetchInstances();
        function reload() {
            objectStoreInstancesStore.fetchInstances();
        }
        const testInstanceUrl = "/api/object_store_instances/{uuid}/test";
        const { ConfigurationTestSummaryModal, showTestResults, testResults, test, testingError } = useInstanceTesting(testInstanceUrl);
        return { __sfc: true, objectStoreInstancesStore, BADGE_FIELD, fields, allItems, activeInstances, loading, reload, testInstanceUrl, ConfigurationTestSummaryModal, showTestResults, testResults, test, testingError, BTable, InstanceDropdown, ManageIndexHeader, LoadingSpan, ObjectStoreBadges, ObjectStoreTypeSpan, TemplateSummarySpan };
    }
});
